const ApiRouter = {
    /**
     * {
        "arrivalCityCode": "",
        "departureCityCode": "",
        "departureDate": "",
        "entCode": "123456abcdef",
        "phone": "13666640460",
        "sign": "f5a864e156f669cefb36c42f8f32ab09",
        md5(arrivalCityCode=&departureCityCode=&departureDate=&entCode=123456abcdef&phone=13666640460&signKey=abc&timestamp=1559192793658&userCode=abcdef123456)
        "timestamp": 1559192793658,
        "userCode": "abcdef123456"
        }
     */
    login: {
        url: '/pi-auth/auth/mk/login',
        method: "POST"
    },
    /**
     * 	
        {
        "cityNumber": 0,
        "domesticSize": 0,
        "hotDomesticSize": 0,
        "queryKeyword": "string",
        "queryNumber": 0
        }
     */
    city: {
        url:'/pi-crawler-api/api/mk/fare/airport/list',
        method:"POST"
    },
    /**
     * 
     * {
        "arrAirportCode": "string",
        "arrCityCode": "string",
        "deptAirportCode": "string",
        "deptCityCode": "string"
        }
     */
    priceCalandar:{
        url:'/pi-crawler-api/api/mk/fare/calendar/floor',
        method:"POST"
    },
    /**
     * 
     * {
        "arrAirportCode": "string",
        "arrAirportName": "string",
        "arrCityCode": "string",
        "arrCityName": "string",
        "deptAirportCode": "string",
        "deptAirportName": "string",
        "deptCityCode": "string",
        "deptCityName": "string",
        "flightNum": "string",
        "goDate": "string"
        }
     */
    track:{
        url:'/pi-crawler-api/api/mk/fare/advisory',
        method:"POST"
    },
    ticketList:{
        url:'/pi-crawler-api/api/mk/fare/flight/fares',
        method:"POST"
    },
    trackFlight:{
        url:'/pi-crawler-api/api/mk/fare/tracking',
        method:"PUT"
    },
    trackList:{
        url:'/pi-crawler-api/api/mk/fare/tracking',
        method:"POST"
    },
    deleteTrack:{
        url:'/pi-crawler-api/api/mk/fare/tracking',
        method:"DELETE"
    },
    /**
     * 
     * {
        "oldTelphone": "string",
        "telphone": "string",
        "type": "string",
        "userId": 0,
        "verifyCode": "string"
        }
     */
    verifyCode:{
        url:'/pi-crawler-appserver/appserver/mk/verifyCode',
        method:"POST"
    },
    /**
     * 
     * {
        "oldTelphone": "string",
        "telphone": "string",
        "type": "string",
        "userId": 0,
        "verifyCode": "string"
        }
     */
    bindPhone:{
        url:'/pi-crawler-appserver/appserver/mk/bindPhoneWithVerifyCode',
        method:"POST"
    },
    chart:{
        url:'/pi-crawler-api/api/mk/fare/retrospect',
        method:"POST"
    },
    /**
     * pageIndex,pageSize
     */
    messageList:{
        url:'/pi-crawler-api/api/mk/fare/tracking/notify',
        method:"POST"
    },
    /**
     * appTraceNotifyLogId
        status: 0
     */
    changeMessage:{
        url:'/pi-crawler-api/api/mk/fare/tracking/notify/status',
        method:"POST"
    },
    deleteMessage:{
        url:'/pi-crawler-api/api/mk/fare/tracking/notify',
        method:"DELETE"
    },
    refreshToken: {
        url:"/pi-auth/auth/mk/refreshToken",
        method:"POST"
    },
    contactList: {
        url:"/pi-crawler-appserver/appserver/mk/liaisons",
        method:"POST"
    },
    addContact:{
        url:"/pi-crawler-appserver/appserver/mk/liaison",
        method:"PUT"
    },
    delContact:{
        url:"/pi-crawler-appserver/appserver/mk/liaison/{id}",
        method:"DELETE"
    },
    detailContact:{
        url:"/pi-crawler-appserver/appserver/mk/priority",
        method:"PUT"
    },
    cityCode:{
        url:"/pi-crawler-api/api/mk/fare/cityCode",
        method:"GET"
    },
    cityName:{
        url:"/pi-crawler-api/api/mk/fare/cityName",
        method:"GET"
    },
    orderPhone:{
        url:"/pi-crawler-appserver/appserver/mk/get/telphone",
        method:"GET"
    },
    selectPhone:{
        url:"/pi-crawler-api/api/mk/fare/tracking/telphone",
        method:"POST"
    },
    isTracked:{
        url:"/pi-crawler-api/api/mk/fare/isTracking",
        method:"POST"
    }
}

module.exports = ApiRouter